var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vue-qr",
    _vm._b(
      { attrs: { text: _vm.src, size: _vm.size } },
      "vue-qr",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }